import { Component, OnInit, Input, Output, EventEmitter, Inject, ViewChild } from '@angular/core';
import { OverviewForm } from 'src/app/workflow/request/newRequest/new-request-model'
import { GipReqManForm } from 'src/app/workflow/request/request.model';
import { SharingDataService } from 'src/app/Services/sharing-data.service'
import { FormularService } from 'src/app/Services/formular.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CommonService } from 'src/app/Services/common.service';
import { ConfirmationWindow } from 'src/app/template/deleteTemplate/confirmationWindow.component';
import { NoteEditDialogComponent } from './noteEditDialog/noteEditDialog.component';
import { ErrorHandlingService } from 'src/app/Services/errorHandling.service';
import { TranslateResourceDefinitionPipe } from 'src/app/shared/pipes/translateResourceDefinition.pipe';
import { DownloadService } from '../../download/download.service';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-gip-req-man-form',
  templateUrl: './gipReqManForm.component.html',
  styleUrls: ['./gipReqManForm.component.css']
})
export class GipReqManFormComponent implements OnInit {
  @Output() public submit = new EventEmitter();
  constructor(
    private shareData: SharingDataService,
    public formularService: FormularService,
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private commonService: CommonService,
    private errorHandlingService: ErrorHandlingService,
    public translateResourceDefinition: TranslateResourceDefinitionPipe,
    private downloadService: DownloadService
  ) { }


  resourceDefinition;

  OverviewForm = OverviewForm;
  gridAssetsDataUrl = "";
  gridAssetsDataUrlDefaultFilter = "";
  gridRequestDocumentDataUrl = "";
  gridRequestDocumentDataUrlDefaultFilter = "";
  id;
  modelInput = GipReqManForm;
  selectedEmailRow;
  MS_REQCASSET_NUrlString;
  showLoading = true;
  groupName="MS_REQ_N";

  formular1 = [
    { formControlName: "G3E_FID", hidden: false, picklist: null, autocomplete: null, required: false, readonly: true, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, function: null, textArea: false, },
    { formControlName: "RQTITLE", hidden: true, picklist: null, autocomplete: null, required: false, readonly: true, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, function: null, textArea: false, title: null },
    { formControlName: "DELIVERY_STATE", hidden: true, picklist: null, autocomplete: null, required: false, readonly: false, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, function: null, inputNumber: false, title: null},
    { formControlName: "REQUEST_STATE", hidden: true, picklist: null, autocomplete: null, required: false, readonly: false, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, function: null, inputString: true, title: null },
    { formControlName: "ACTIVITY_TYPE", hidden: false, picklist: "V_MS_ACTIVITY_TYPE_VL_T", autocomplete: null, required: false, readonly: true, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, function: null, textArea: false, title: null, newRow: true },
    { formControlName: "REASON_TYPE", hidden: false, picklist: "V_MS_REASON_TYPE_VL_T", autocomplete: null, required: false, readonly: true, datepicker: false, datepickerType: false, datepickerMax: null, datepickerMin: null, function: null, textArea: false, title: null },
    { formControlName: "BEGIN_ACTIVITY_DT", hidden: false, picklist: null, autocomplete: null, required: false, readonly: true, datepicker: true, datepickerType: null, datepickerMax: null, datepickerMin: null, function: null, textArea: false, title: null, newRow: true },
    { formControlName: "END_ACTIVITY_DT", hidden: false, picklist: null, autocomplete: null, required: false, readonly: true, datepicker: true, datepickerType: null, datepickerMax: null, datepickerMin: null, function: null, textArea: false, title: null },
    { formControlName: "PERSON_ID", hidden: true, picklist: null, autocomplete: null, required: false, readonly: true, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, function: null, textArea: false, title: null, newRow: true },
    { formControlName: "FULLNAME", hidden: false, picklist: null, autocomplete: null, required: false, readonly: true, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, function: null, textArea: false, title: "REQFOR"},
    { formControlName: "PERSON_EMAIL", hidden: false, picklist: null, autocomplete: null, required: false, readonly: true, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, function: null, textArea: false, title: null },
    { formControlName: "CONTRACT_NUMBER", hidden: false, picklist: null, autocomplete: null, required: false, readonly: true, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, function: null, textArea: false, title: null, newRow: true },
    { formControlName: "CONTRACT_NAME", hidden: false, picklist: null, autocomplete: null, required: false, readonly: true, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, function: null, textArea: false, title: null },
    { formControlName: "LOCATION_DESC", hidden: false, picklist: null, autocomplete: null, required: false, readonly: true, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, function: null, inputString: false, textArea: true, title: "DESCANDMEASURE"},
    { formControlName: "NOTE", hidden: true, picklist: null, autocomplete: null, required: false, readonly: true, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, function: null, textArea: true, title: null },
    { formControlName: "INTNOTE", hidden: false, picklist: null, autocomplete: null, required: false, readonly: true, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, function: null, textArea: true, title: "FORWARDEDREQ" },
    { formControlName: "PERSON_NOTIF", hidden: false, picklist: null, modalWindow: true, autocomplete: null, required: false, readonly: false, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, function: "personMailModalWindow", inputString: false, title: "cptn_InternalCommunication"},
  ];

  formular2 = [
    { formControlName: "RESPONSIBLE_PERSON", hidden: false, picklist: null, autocomplete: null, required: false, readonly: true, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, function: null, textArea: false, },
    { formControlName: "RESPONSIBLE_PERSON_TEL_NUM", hidden: false, picklist: null, autocomplete: null, required: false, readonly: true, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, function: null, textArea: false, title: null },
    { formControlName: "PERSON_EMAIL", hidden: false, picklist: null, autocomplete: null, required: false, readonly: true, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, function: null, textArea: false, title: null },
  ]

  formular3 = [
    { formControlName: "SERVICE", hidden: false, picklist: "V_MS_SERVICE_VL_T", autocomplete: null, required: false, readonly: false, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, function: null, textArea: false,},
  ]
    
  columnsAssets = [
    { name: "G3E_CID", visible: true, enableFilter: true, enableOrderBy: true, export: false, type: "text", columnSearch: true, fromToFilter: false, picklistTableName: null, function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
    { name: "SERVICE", visible: true, enableFilter: true, enableOrderBy: true, export: false, type: "picklist", columnSearch: false, fromToFilter: false, picklistTableName: "V_MS_SERVICE_VL_T", function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
    { name: "STATUS", visible: true, enableFilter: true, enableOrderBy: true, export: false, type: "picklist", columnSearch: false, fromToFilter: false, picklistTableName: "MS_REQSERVICE_STATUS_VL_T", function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "REMARK", visible: true, enableFilter: true, enableOrderBy: true, export: false, type: "text", columnSearch: true, fromToFilter: false, picklistTableName: null, function: "openNoteEditDialog", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
  ];
  columnsRequestDocument = [
    { name: "MAPSHEET_NUM", visible: false, enableFilter: true, enableOrderBy: true, export: false, type: "text", columnSearch: true, fromToFilter: false, picklistTableName: null, function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
    { name: "SERVICE", visible: true, enableFilter: true, enableOrderBy: true, export: false, type: "text", columnSearch: true, fromToFilter: false, picklistTableName: null, function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
    { name: "USERNAME", visible: true, enableFilter: true, enableOrderBy: true, export: false, type: "text", columnSearch: true, fromToFilter: false, picklistTableName: null, function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
    { name: "DOWNLOAD_DT", visible: false, enableFilter: true, enableOrderBy: true, export: false, type: "date", columnSearch: false, fromToFilter: false, picklistTableName: null, function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
    { name: "DNLOAD", visible: true, enableFilter: true, enableOrderBy: true, export: false, type: "icon", columnSearch: false, fromToFilter: false, picklistTableName: null, function: "download", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, icon: "save" },
    { name: "btn_delete", visible: true, enableFilter: true, enableOrderBy: true, export: false, type: "icon", columnSearch: false, fromToFilter: false, picklistTableName: null, function: "delete", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, icon: "delete" },
  ];

  MS_REQCASSET_NColumns = [
    { name: "G3E_FID", visible: false, enableFilter: false, enableOrderBy: true, export: false, type: "text", columnSearch: false, fromToFilter: false, picklistTableName: null, function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "G3E_CID", visible: true, enableFilter: false, enableOrderBy: true, export: false, type: "text", columnSearch: false, fromToFilter: false, picklistTableName: null, function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "REF_SERVICE", visible: true, enableFilter: false, enableOrderBy: true, export: false, type: "picklist", columnSearch: false, fromToFilter: false, picklistTableName: "V_MS_SERVICE_VL_T", function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "REF_G3E_FNO", visible: true, enableFilter: false, enableOrderBy: true, export: false, type: "picklist", columnSearch: false, fromToFilter: false, picklistTableName: "V_MS_FEATURE_VL_T", function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "REF_G3E_FID", visible: true, enableFilter: false, enableOrderBy: true, export: false, type: "text", columnSearch: false, fromToFilter: false, picklistTableName: null, function: null, CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null },
    { name: "EXTERNAL_CALL", visible: true, enableFilter: false, enableOrderBy: false, export: false, type: "icon", columnSearch: false, fromToFilter: false, picklistTableName: null, function: "externalCall", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultNumberFilter: null, icon: "search" },
  ]

  @ViewChild('fileInput') fileName;

  ngOnInit(): void {
    this.shareData.currentResourceDefinition.subscribe(data => this.resourceDefinition = data);
    this.modelInput.reset();
    this.route.queryParams
      .subscribe(params => {
        this.id = params.g3e_fid;
      });
    if (this.id != undefined) {
      this.getData();
      this.gridAssetsDataUrl = `Data/MS_REQSERV_N`;
      this.gridAssetsDataUrlDefaultFilter = `G3E_FID eq ${this.id}`;
      this.gridRequestDocumentDataUrl = `Data/V_MS_REQDOC_MAN`;
      this.gridRequestDocumentDataUrlDefaultFilter = `G3E_FID eq ${this.id}`;
    }
  }

  openNoteEditDialog(element) {
    var newNote: string
    let dialogRef = this.dialog.open(NoteEditDialogComponent, {
      autoFocus: true,
      minHeight: "30%",
      minWidth: "30%",
      data: element.REMARK
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.newNote.subscribe(result => {
        newNote = result;
        console.log(newNote);
        this.updateNote(element, newNote);

        dialogSubmitSubscription.unsubscribe();
      });
  }

  updateNote(object: any, note: string) {
    console.log(object);

    this.formularService.updateData(`data/MS_REQSERV_N(${object.G3E_ID})`, { G3E_ID: object.G3E_ID, REMARK: note }, (response) => {
      object.REMARK = note;
      this.errorHandlingService.showSuccess(undefined, undefined);

    });
  }

  getData() {
    let urls = [
      `Data/MS_REQ_N?$filter=G3E_FID eq ${this.id}`,
    ];
    var data = this.formularService.getData(urls, (reqData) => {
      if (reqData[0][0] != undefined) {
        for (var dataElement in reqData[0][0]) {
          for (var statisticElement in this.modelInput.value) {
            if (dataElement == statisticElement) {
              this.modelInput.controls[statisticElement].setValue(reqData[0][0][dataElement])
            }
          }
        }
        var contractData = this.formularService.getData([`data/MS_CONTRACT?$filter=ID eq ${this.modelInput.value.CONTRACT_ID}`], (data) => {
          if (data[0][0] != undefined) {
            for (var dataElement in data[0][0]) {
              for (var statisticElement in this.modelInput.value) {
                ``
                if (dataElement == statisticElement) {
                  this.modelInput.controls[statisticElement].setValue(data[0][0][dataElement])
                }
              }
            }
          }
          this.showLoading = false;
        });
      }
      this.formular1.forEach(element => {
        if (element.formControlName == "INTNOTE" && this.modelInput.value.INTNOTE != null) {

        }
      });
      var temporaryMS_REQCASSET_NColumns = this.MS_REQCASSET_NColumns;
      this.MS_REQCASSET_NColumns = null;
      this.MS_REQCASSET_NColumns = temporaryMS_REQCASSET_NColumns;

      this.MS_REQCASSET_NUrlString = `data/MS_REQCASSET_N`;

      this.MS_REQCASSET_NColumns.forEach(element => {
        if (element.name == "G3E_FID") {
          element.defaultNumberFilter = [reqData[0][0].G3E_FID];
        }
      });
    });
  }

  fileToUpload: File = null;
  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  upload() {
    this.gridRequestDocumentDataUrl = null;
    console.log(this.modelInput)
    var url: string;
    if(this.modelInput.value.SERVICE){
      url = `file/ReqDocFile/${this.modelInput.value.G3E_FID}/${this.modelInput.value.SERVICE}`;
    } else {
      url = (`file/ReqDocFile/${this.modelInput.value.G3E_FID}`);
    }
    this.downloadService.uploadFile(url, this.fileToUpload, (data) => {
      this.gridRequestDocumentDataUrl = `Data/V_MS_REQDOC_MAN`;
    }, this.handlePostError);
      
  }

  handlePostError(response: any){
    var error = '';

    if (response.status == 400)
          this.errorHandlingService.showError(this.translateResourceDefinition.transform('ServiceSaveError', this.resourceDefinition, 'KEY_NAME', 'LONG_TEXT', "Common"), undefined);
    else if (response.status == 431){
      error = this.translateResourceDefinition.transform("FileTooLarge", this.resourceDefinition, "KEY_NAME", "LONG_TEXT", "Common")
      this.errorHandlingService.showError(error);
    } else if(response.status == 415){
      error = this.translateResourceDefinition.transform("UnsupportedMediaType", this.resourceDefinition, "KEY_NAME", "LONG_TEXT", "Common")
      this.errorHandlingService.showError(error);
    }
    else {
      error = this.downloadService.getDefaultErrorMessage();
      this.errorHandlingService.showError(error);
    }
  }

  action(action) {
    this[action]();
  }

  gridAction(parameters) {
    this[parameters.action](parameters.element, parameters.column);
  }

  externalCall(){
    
  }

  download(element, column) {
    this.downloadService.downloadFile(this.commonService.getGipServicesUrl() + 'file/ReqDocFileTest/' + element.G3E_ID, (result) => {
      if(result.type == "application/pdf"){
        var url = URL.createObjectURL(result); 
        window.open(url,'_blank');
      } else {
        FileSaver.saveAs(result,  element.USERNAME);
      }
    }, (err) => {
      if (err.status == 400)
        this.errorHandlingService.showError(this.translateResourceDefinition.transform('ServiceFileDispErr', this.resourceDefinition, 'KEY_NAME', 'LONG_TEXT', "Common"), undefined)
      else if(err.status < 200 || err.status > 206)
        this.errorHandlingService.showError(this.translateResourceDefinition.transform('PortalTechnicalFail', this.resourceDefinition, 'KEY_NAME', "LONG_TEXT", "Common"), undefined)
    });
  }

  delete(element, column) {
    const dialogRef = this.dialog.open(ConfirmationWindow, {
      data: {
        Title : "ConfirmDeleteTitle",
        Text : "ConfirmDeleteText",
        Placeholders: [element.USERNAME],
        Actions: [{
          Text: "ConfirmYes",
          Function: "REMOVE",
        },
        {
          Text: "ConfirmNo",
        }]
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "REMOVE") {
        this.gridRequestDocumentDataUrl = null;
        this.formularService.deleteData(`file/ReqDocDeleteFile/${element.G3E_ID}`, (data) => {
          this.gridRequestDocumentDataUrl = `Data/V_MS_REQDOC_MAN`;
        });
      }
    });
  }

  onInput(){
    let filename = this.fileName.nativeElement.files[0].name;
    if (filename != undefined){
      let fileHasBeenSelected = this.translateResourceDefinition.transform("fileHasBeenSelected", this.resourceDefinition, 'KEY_NAME', 'LONG_TEXT', "Common");
      fileHasBeenSelected = fileHasBeenSelected.replace("{0}",filename);
      
      this.errorHandlingService.showInfo('', fileHasBeenSelected);
    }
  }

  searchAttribute() {
    this.router.navigate(["/gipReqMan"], { queryParams: { g3e_fid: this.modelInput.controls.G3E_FID.value } });
  }

  back() {
    this.router.navigate(["/gipReqManList"]);
  }

  forward() {
    this.router.navigate(["/gipReqManFwdForm"], { queryParams: { g3e_fid: this.modelInput.controls.G3E_FID.value, isEdit: true } });
  }

  personMailModalWindow() {
    const dialogRef = this.dialog.open(personMailDialog, {
      data: {actualSelectedRows: this.selectedEmailRow}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        console.log(result)
        this.selectedEmailRow = result;
        this.selectedEmailRow.forEach(element => {
          if (this.modelInput.value.PERSON_NOTIF == null) {
            this.modelInput.controls.PERSON_NOTIF.setValue(`${element.EMAIL}`);
          } else {
            this.modelInput.controls.PERSON_NOTIF.setValue(`${this.modelInput.value.PERSON_NOTIF},${element.EMAIL}`);
          }
        });
        this.shareData.changePersonNotif(this.modelInput.value.PERSON_NOTIF);
      }
    });
  }
}


@Component({
  selector: 'personMailDialog',
  templateUrl: 'personMailDialog.html',
})
export class personMailDialog {
  resourceDefinition;
  PersonIDGrid
  actualSelectedRows;
  groupName="V_MS_USER";

  constructor(
    private shareData: SharingDataService,
    public dialogRef: MatDialogRef<personMailDialog>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    shareData.currentResourceDefinition.subscribe(data => this.resourceDefinition = data);
    this.actualSelectedRows = data.actualSelectedRows;

    this.PersonIDGrid = [
      { name: "select",       visible: true,  enableFilter: false,  enableOrderBy: false, enableSelect: true,   export: false, type: "multiSelect", columnSearch: false, fromToFilter: false, picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
      { name: "USERGUID",     visible: false, enableFilter: true,   enableOrderBy: true,  enableSelect: true,   export: false, type: "text", columnSearch: true, fromToFilter: false, picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
      { name: "TITLE",        visible: true,  enableFilter: true,   enableOrderBy: true,  enableSelect: true,   export: false, type: "text", columnSearch: true, fromToFilter: false, picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
      { name: "NAME",         visible: true,  enableFilter: true,   enableOrderBy: true,  enableSelect: true,   export: false, type: "text", columnSearch: true, fromToFilter: false, picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
      { name: "SURNAME",      visible: true,  enableFilter: true,   enableOrderBy: true,  enableSelect: true,   export: false, type: "text", columnSearch: true, fromToFilter: false, picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
      { name: "FULLNAME",     visible: false, enableFilter: true,   enableOrderBy: true,  enableSelect: true,   export: false, type: "text", columnSearch: true, fromToFilter: false, picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
      { name: "EMAIL",        visible: true,  enableFilter: true,   enableOrderBy: true,  enableSelect: true,   export: false, type: "text", columnSearch: true, fromToFilter: false, picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
      { name: "PHONE",        visible: false, enableFilter: true,   enableOrderBy: true,  enableSelect: true,   export: false, type: "text", columnSearch: true, fromToFilter: false, picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
      { name: "CONTRACT",     visible: true,  enableFilter: true,   enableOrderBy: true,  enableSelect: true,   export: false, type: "picklistText", columnSearch: false, fromToFilter: false, picklistTableName: "V_MS_CONTRACT_VL", function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
      { name: "COMPANY_MID",  visible: true,  enableFilter: true,   enableOrderBy: true,  enableSelect: true,   export: false, type: "picklistText", columnSearch: false, fromToFilter: false, picklistTableName: "V_MS_COMPANY_VL", function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
      { name: "CONTRACT_EXP", visible: false, enableFilter: true,   enableOrderBy: true,  enableSelect: true,   export: false, type: "text", columnSearch: true, fromToFilter: false, picklistTableName: null, function: "Select", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null, defaultFilter: null },
    ]
  
  }

  selectedRows;
  urlString = "data/V_MS_USER"
  defaultOrderby = [["SURNAME"],["up"]];

  
  action(parameters){
    this[parameters.action](parameters.element, parameters.column, parameters.selectedSingleRows, parameters.selectedMultiRows);
  }

  Select(element, column, selectedSingleRows, selectedMultiRows){
    this.selectedRows = selectedMultiRows;
  }

  close() {
    this.dialogRef.close();
  }

}